import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Users, LogOut, Gamepad2 } from "lucide-react";

export default function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium transition ${
      isActive
        ? "bg-sky-50 text-sky-700"
        : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
    }`;

  return (
    <div className="clinic-mode min-h-screen flex">
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col" data-testid="dashboard-sidebar">
        <div className="p-6 border-b border-slate-200">
          <Link to="/dashboard" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-400 to-pink-400 flex items-center justify-center text-white font-bold">M</div>
            <span className="text-lg font-semibold tracking-tight">Mundo NeuroKids</span>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          <NavLink to="/dashboard" end className={linkClass} data-testid="nav-dashboard">
            <LayoutDashboard size={18} /> Visão geral
          </NavLink>
          <NavLink to="/dashboard/children" className={linkClass} data-testid="nav-children">
            <Users size={18} /> Crianças
          </NavLink>
          <Link to="/play" className="flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium text-amber-700 hover:bg-amber-50 transition" data-testid="nav-play">
            <Gamepad2 size={18} /> Abrir modo criança
          </Link>
        </nav>
        <div className="p-4 border-t border-slate-200">
          <div className="text-xs text-slate-500">Conectado como</div>
          <div className="text-sm font-medium text-slate-900 truncate" data-testid="user-name">{user?.name}</div>
          <div className="text-xs text-slate-500 truncate">{user?.email}</div>
          <button
            onClick={onLogout}
            className="mt-3 w-full flex items-center justify-center gap-2 px-3 py-2 text-sm border border-slate-200 rounded-lg hover:bg-slate-50 transition"
            data-testid="logout-button"
          >
            <LogOut size={16} /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="max-w-6xl mx-auto p-6 md:p-10">{children}</div>
      </main>
    </div>
  );
}
